import Dropdown from "react-bootstrap/Dropdown";
import SessionTimer from "./SessionTimer";
import { FaCopy } from "react-icons/fa6";
import { ToastContainer, toast } from "react-toastify";
import { AiOutlineLogout } from "react-icons/ai";
import { FaUserCircle } from "react-icons/fa";

export function CommonHeaders() {




    return (

        <header
            style={{
                width: "100%",
                background:
                    "linear-gradient(135deg,#0f172a,#1e293b)",
                padding: "14px 28px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                boxShadow:
                    "0 4px 20px rgba(0,0,0,0.08)",
                position: "sticky",
                top: 0,
                zIndex: 999
            }}
        >

            {/* LEFT LOGO */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "14px"
                }}
            >

                <div className="aphe-logo-emblem">
                    <img src="../images/chelogo.png" alt="logo" />
                </div>
                <div>

                    <h4
                        style={{
                            margin: 0,
                            color: "#fff",
                            fontWeight: "700",
                            fontSize: "22px"
                        }}
                    >
                        Commissionerate of Higher Education
                    </h4>

                    <p
                        style={{
                            margin: 0,
                            color: "#cbd5e1",
                            fontSize: "14px",
                            marginTop: "4px"
                        }}
                    >
                        Government of Andhra Pradesh
                    </p>
                </div>
            </div>

            {/* RIGHT SECTION */}

        </header>
    );
}

/* FOOTER */

export function CommonFooter() {

    return (

        <footer
            style={{
                background:
                    "linear-gradient(135deg,#0f172a,#1e293b)",
                padding: "18px",
                textAlign: "center",
                marginTop: "30px"
            }}
        >

            <p
                style={{
                    color: "#fff",
                    margin: 0,
                    fontSize: "14px"
                }}
            >
                Designed and Developed by &nbsp;

                <a
                    href="https://apcfss.in/"
                    target="_blank"
                    rel="noreferrer"
                >
                    <img
                        src="../images/footer-logo.svg"
                        alt="APCFSS"
                        style={{
                            height: "32px",
                            objectFit: "contain"
                        }}
                    />
                </a>
            </p>
        </footer>
    );
}